// @flow

import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';

import styles from './styles.scss';

import type { DefaultStateType } from '../../redux/reducers';

type Props = {
  studioInternalName: string,
  hoveredStudioInternalName: string,
  navigateToStudio: string => void,
};

const CampusMap = (props: Props) => {
  const handleClick = e => props.navigateToStudio(e.target.parentElement.id);

  return (
    <div className={styles.svgWrap}>
      <svg viewBox="0 0 795.56 612">
        <g id="BG" />
        <g id="TEXT">
          <g id="Слой_24">
            <text fill="#616161" fontFamily="ArialMT, Arial" fontSize="11.93" transform="translate(71.28 327.7)">
              <tspan xmlSpace="preserve">WINONA AVE</tspan>
            </text>
            <text fill="#616161" fontFamily="ArialMT, Arial" fontSize="8.85" transform="translate(101.71 240.29)">
              Community
            </text>
            <text fill="#616161" fontFamily="ArialMT, Arial" fontSize="8.85" transform="translate(114.04 250.48)">
              Bank
            </text>
          </g>
          <text fill="#b2b2b2" fontFamily="ArialMT, Arial" fontSize="8.85" transform="translate(81.2 383.87)">
            CENTERSTAGING
          </text>
          <text fill="#b2b2b2" fontFamily="ArialMT, Arial" fontSize="8.85" transform="translate(93.53 394.19)">
            GUEST AND
          </text>
          <text fill="#b2b2b2" fontFamily="ArialMT, Arial" fontSize="8.85" transform="translate(84.68 404.38)">
            CREW PARKING
          </text>
          <text
            fill="#616161"
            fontFamily="ArialMT, Arial"
            fontSize="11.93"
            transform="translate(43.13 386.68) rotate(-90)"
          >
            <tspan xmlSpace="preserve">N HOLLYWOOD WAY</tspan>
          </text>
          <text
            fill="#616161"
            fontFamily="ArialMT, Arial"
            fontSize="8.85"
            transform="translate(7.87 354.51) rotate(-90)"
          >
            Burbank Airport
          </text>
          <text
            fill="#616161"
            fontFamily="ArialMT, Arial"
            fontSize="8.85"
            transform="translate(7.87 612.03) rotate(-90)"
          >
            &lt;&lt; to Burbank Airport entrance and terminal
          </text>
          <text
            fill="#616161"
            fontFamily="ArialMT, Arial"
            fontSize="8.85"
            transform="translate(7.87 233.72) rotate(-90)"
          >
            to I-5 &gt;&gt;
          </text>
          <text fill="#616161" fontFamily="ArialMT, Arial" fontSize="8.85" transform="translate(174.1 345.57)">
            3410
          </text>
          <text fill="#616161" fontFamily="ArialMT, Arial" fontSize="5.9" transform="translate(215.79 281.49)">
            NO PARKING
          </text>
          <text fill="#b2b2b2" fontFamily="ArialMT, Arial" fontSize="5.9" transform="translate(175.71 447.14)">
            New Studio
          </text>
          <text fill="#b2b2b2" fontFamily="ArialMT, Arial" fontSize="5.9" transform="translate(182.81 454.11)">
            Under
          </text>
          <text fill="#b2b2b2" fontFamily="ArialMT, Arial" fontSize="5.9" transform="translate(174.23 460.95)">
            Construction
          </text>
          <text fill="#b2b2b2" fontFamily="ArialMT, Arial" fontSize="5.9" transform="translate(175.71 384.94)">
            New Studio
          </text>
          <text fill="#b2b2b2" fontFamily="ArialMT, Arial" fontSize="5.9" transform="translate(182.81 391.78)">
            Under
          </text>
          <text fill="#b2b2b2" fontFamily="ArialMT, Arial" fontSize="5.9" transform="translate(174.23 398.75)">
            Construction
          </text>
          <text fill="#b2b2b2" fontFamily="ArialMT, Arial" fontSize="5.9" transform="translate(172.63 560.01)">
            C
          </text>
          <text fill="#b2b2b2" fontFamily="ArialMT, Arial" fontSize="5.9" transform="translate(184.96 560.01)">
            B
          </text>
          <text fill="#b2b2b2" fontFamily="ArialMT, Arial" fontSize="5.9" transform="translate(197.16 560.01)">
            A
          </text>
          <text fill="#fff" fontFamily="ArialMT, Arial" fontSize="11.93" transform="translate(216.19 596.08)">
            Cafe
          </text>
          <text fill="#616161" fontFamily="ArialMT, Arial" fontSize="8.85" transform="translate(343.28 307.68)">
            3407
          </text>
          <text fill="#616161" fontFamily="ArialMT, Arial" fontSize="8.85" transform="translate(266.2 345.57)">
            3400 - 3406
          </text>
          <text fill="#616161" fontFamily="ArialMT, Arial" fontSize="8.85" transform="translate(344.49 571.32)">
            3350
          </text>
          <text fill="#616161" fontFamily="ArialMT, Arial" fontSize="5.9" transform="translate(275.58 281.49)">
            NO PARKING
          </text>
          <text fill="#616161" fontFamily="ArialMT, Arial" fontSize="5.9" transform="translate(465.67 369.61)">
            NO PARKING
          </text>
          <text
            fill="#616161"
            fontFamily="ArialMT, Arial"
            fontSize="5.9"
            transform="translate(316.87 84.65) rotate(-90)"
          >
            NO PARKING
          </text>
          <text
            fill="#616161"
            fontFamily="ArialMT, Arial"
            fontSize="5.9"
            transform="translate(399.15 62.77) rotate(80.5)"
          >
            NO PARKING
          </text>
          <text fill="#b2b2b2" fontFamily="ArialMT, Arial" fontSize="8.85" transform="translate(390.6 552.24)">
            ARTIST PARKING ONLY
          </text>
          <text fill="#b2b2b2" fontFamily="ArialMT, Arial" fontSize="8.4" transform="translate(285.41 480.39)">
            STUDIO
          </text>
          <text fill="#b2b2b2" fontFamily="ArialMT, Arial" fontSize="8" transform="translate(282.41 490.39)">
            SUPPORT
          </text>
          <text fill="#b2b2b2" fontFamily="ArialMT, Arial" fontSize="8.85" transform="translate(333.9 17.89)">
            ARTIST
          </text>
          <text fill="#b2b2b2" fontFamily="ArialMT, Arial" fontSize="8.85" transform="translate(329.61 28.22)">
            PARKING
          </text>
          <text fill="#b2b2b2" fontFamily="ArialMT, Arial" fontSize="8.85" transform="translate(337.51 38.54)">
            ONLY
          </text>
          <text
            fill="#616161"
            fontFamily="ArialMT, Arial"
            fontSize="11.93"
            transform="translate(756.71 277.56) rotate(90)"
          >
            <tspan xmlSpace="preserve">N ONTARIO ST</tspan>
          </text>
          <text fill="#616161" fontFamily="ArialMT, Arial" fontSize="11.93" transform="translate(665.28 564.17)">
            Admin Offices
          </text>
          <text fill="#616161" fontFamily="ArialMT, Arial" fontSize="11.93" transform="translate(643.97 577.84)">
            2517 N Ontario St
          </text>
          <text fill="#616161" fontFamily="ArialMT, Arial" fontSize="8.85" transform="translate(530.69 386.41)">
            Sports Tutor
          </text>
          <text fill="#616161" fontFamily="ArialMT, Arial" fontSize="11.93" transform="translate(668.63 591.52)">
            <tspan xmlSpace="preserve">Burbank, CA</tspan>
          </text>
          <text fill="#616161" fontFamily="ArialMT, Arial" fontSize="11.93" transform="translate(706.44 605.33)">
            91504
          </text>
          <text fill="#616161" fontFamily="ArialMT, Arial" fontSize="8.85" transform="translate(528.01 326.63)">
            to admin offices
          </text>
          <text fill="#616161" fontFamily="ArialMT, Arial" fontSize="8.85" transform="translate(416.61 268.18)">
            UPP
          </text>
        </g>
        <g
          id="studio-1"
          className={classnames({
            [styles.isHovered]: props.hoveredStudioInternalName === 'studio-1',
            [styles.isCurrent]: props.studioInternalName === 'studio-1',
          })}
          onClick={handleClick}
        >
          <rect x="325.72" y="152.62" width="47.32" height="34.45" />
          <text fontFamily="ArialMT, Arial" fontSize="11.93" transform="translate(336.44 174.07)">
            S 1
          </text>
        </g>
        <g
          id="studio-2"
          className={classnames({
            [styles.isHovered]: props.hoveredStudioInternalName === 'studio-2',
            [styles.isCurrent]: props.studioInternalName === 'studio-2',
          })}
          onClick={handleClick}
        >
          <rect x="325.72" y="195.65" width="47.32" height="34.45" />
          <text fill="#fff" fontFamily="ArialMT, Arial" fontSize="11.93" transform="translate(336.58 217.1)">
            S 2
          </text>
        </g>
        <g
          id="studio-3"
          className={classnames({
            [styles.isHovered]: props.hoveredStudioInternalName === 'studio-3',
            [styles.isCurrent]: props.studioInternalName === 'studio-3',
          })}
          onClick={handleClick}
        >
          <rect x="325.72" y="231.18" width="30.03" height="16.71" />
          <text fontFamily="ArialMT, Arial" fontSize="11.93" transform="translate(331.62 243.91)">
            S 3
          </text>
        </g>
        <g
          id="studio-6"
          className={classnames({
            [styles.isHovered]: props.hoveredStudioInternalName === 'studio-6',
            [styles.isCurrent]: props.studioInternalName === 'studio-6',
          })}
          onClick={handleClick}
        >
          <polygon points="457.76 575.52 457.76 594.33 450.2 594.33 450.2 607.92 457.76 607.92 503.66 607.92 511.16 607.92 511.16 573.52 457.76 573.52" />
          <text fontFamily="ArialMT, Arial" fontSize="11.93" transform="translate(475.73 595.94)">
            S 6
          </text>
        </g>
        <g
          id="studio-7"
          className={classnames({
            [styles.isHovered]: props.hoveredStudioInternalName === 'studio-7',
            [styles.isCurrent]: props.studioInternalName === 'studio-7',
          })}
          onClick={handleClick}
        >
          <rect x="406.69" y="582" width="35.52" height="26.5" />
          <text fontFamily="ArialMT, Arial" fontSize="11.93" transform="translate(419.29 595.94)">
            S 7
          </text>
        </g>
        <g
          id="studio-8"
          className={classnames({
            [styles.isHovered]: props.hoveredStudioInternalName === 'studio-8',
            [styles.isCurrent]: props.studioInternalName === 'studio-8',
          })}
          onClick={handleClick}
        >
          <rect x="355.02" y="575.36" width="50.64" height="32.55" />
          <text fontFamily="ArialMT, Arial" fontSize="11.93" transform="translate(371.3 595.94)">
            S 8
          </text>
        </g>
        <g
          id="studio-9"
          className={classnames({
            [styles.isHovered]: props.hoveredStudioInternalName === 'studio-9',
            [styles.isCurrent]: props.studioInternalName === 'studio-9',
          })}
          onClick={handleClick}
        >
          <polygon points="324.85 575.3 324.85 596.57 302.88 596.57 302.88 607.91 324.85 607.91 327.54 607.91 353.63 607.91 353.63 575.3 324.85 575.3" />
          <text fontFamily="ArialMT, Arial" fontSize="11.93" transform="translate(330.54 595.94)">
            S 9
          </text>
        </g>
        <g
          id="studio-10"
          className={classnames({
            [styles.isHovered]: props.hoveredStudioInternalName === 'studio-10',
            [styles.isCurrent]: props.studioInternalName === 'studio-10',
          })}
          onClick={handleClick}
        >
          <rect x="250.01" y="575.3" width="51.35" height="33.2" />
          <text fontFamily="ArialMT, Arial" fontSize="11.93" transform="translate(263.65 595.94)">
            S 10
          </text>
        </g>
        <g
          id="studio-11"
          className={classnames({
            [styles.isHovered]: props.hoveredStudioInternalName === 'studio-11',
            [styles.isCurrent]: props.studioInternalName === 'studio-11',
          })}
          onClick={handleClick}
        >
          <rect x="168.74" y="488.25" width="43.47" height="60" />
          <text fontFamily="ArialMT, Arial" fontSize="11.93" transform="translate(178.66 519.85)">
            S 11
          </text>
        </g>
        <g
          id="studio-12"
          className={classnames({
            [styles.isHovered]: props.hoveredStudioInternalName === 'studio-12',
            [styles.isCurrent]: props.studioInternalName === 'studio-12',
          })}
          onClick={handleClick}
        >
          <rect x="168.74" y="575.3" width="41.49" height="33.2" />
          <text fontFamily="ArialMT, Arial" fontSize="11.93" transform="translate(177.32 596.08)">
            S 12
          </text>
        </g>
        <g
          id="studio-13"
          className={classnames({
            [styles.isHovered]: props.hoveredStudioInternalName === 'studio-13',
            [styles.isCurrent]: props.studioInternalName === 'studio-13',
          })}
          onClick={handleClick}
        >
          <rect x="168.74" y="425.25" width="45" height="51" />
          <text fontFamily="ArialMT, Arial" fontSize="11.93" transform="translate(178.66 455.85)">
            S 13
          </text>
        </g>
        <g
          id="studio-14"
          className={classnames({
            [styles.isHovered]: props.hoveredStudioInternalName === 'studio-14',
            [styles.isCurrent]: props.studioInternalName === 'studio-14',
          })}
          onClick={handleClick}
        >
          <rect x="170" y="363" width="43.47" height="51" />
          <text fontFamily="ArialMT, Arial" fontSize="11.93" transform="translate(178.66 390.85)">
            S 14
          </text>
        </g>
      </svg>
    </div>
  );
};

const mapStateToProps = (state: DefaultStateType): { hoveredStudioInternalName: string } => ({
  hoveredStudioInternalName: state.hoveredStudioInternalName,
});

export default connect(mapStateToProps)(CampusMap);



// WEBPACK FOOTER //
// ./src/components/Studio/CampusMap.js